import { Box, Stack, Typography } from "@mui/material";
import { getDollarValue } from "../../helpers/currency";

const TOTALS_ID = "totals";

const HEALTH_COLORS = {
  green: "hubColors.greenMain",
  yellow: "hubColors.yellowMain",
  red: "hubColors.redMain",
};

export const getHeaderItems = (weeks = []) => [
  { id: "customerName", label: "Customer" },
  ...weeks.map((w) => ({ id: w.key, label: w.label })),
  { id: "total", label: "Total" },
];

const HealthDot = ({ health }) => {
  if (!health) return null;
  return (
    <Box
      sx={{
        width: 5,
        height: 5,
        borderRadius: "50%",
        backgroundColor: HEALTH_COLORS[health] || HEALTH_COLORS.green,
        display: "inline-block",
        flexShrink: 0,
      }}
    />
  );
};

const ValueWithDot = ({ value, health, fontWeight = 400 }) => (
  <Stack direction="row" gap="7px" alignItems="center">
    <HealthDot health={health} />
    <Typography
      variant="caption"
      fontSize={11}
      fontWeight={fontWeight}
      color={value ? "text.primary" : "text.disabled"}
    >
      {value ? getDollarValue(value) : "—"}
    </Typography>
  </Stack>
);

const CustomerCell = ({ item, onNavigate }) => (
  <Typography
    variant={
      item.customerId === TOTALS_ID ? "boldCaptionL" : "boldCaptionMainL"
    }
    fontSize={12}
    fontWeight={item.customerId === TOTALS_ID ? 700 : 600}
    sx={{
      cursor: item.customerId !== TOTALS_ID ? "pointer" : "default",
    }}
    onClick={(e) => {
      e.stopPropagation();
      if (item.customerId !== TOTALS_ID) onNavigate(item.customerId);
    }}
  >
    {item.customerName}
  </Typography>
);

const WeekCell = ({ item, weekKey }) => {
  const val = item.weeks?.[weekKey];
  const isTotals = item.customerId === TOTALS_ID;
  const health = isTotals
    ? item.weekHealth?.[weekKey]
    : item.weekHealth?.[weekKey];
  return (
    <ValueWithDot
      value={val}
      health={val ? health : null}
      fontWeight={isTotals ? 700 : 400}
    />
  );
};

const TotalCell = ({ item }) => (
  <ValueWithDot value={item.total} health={item.health} fontWeight={700} />
);

export const getKeys = (weeks = [], onNavigate) => [
  {
    value: "customerName",
    CustomComponent: ({ item }) => (
      <CustomerCell item={item} onNavigate={onNavigate} />
    ),
  },
  ...weeks.map((w) => ({
    value: w.key,
    CustomComponent: ({ item }) => <WeekCell item={item} weekKey={w.key} />,
  })),
  {
    value: "total",
    CustomComponent: TotalCell,
  },
];

export const buildRows = (customers = [], weekTotals = {}, weekHealth = {}) => {
  const grandTotal = customers.reduce((sum, c) => sum + c.total, 0);
  const allWOs = customers.flatMap(() => []);
  const totalsRow = {
    customerId: TOTALS_ID,
    customerName: "Total",
    weeks: weekTotals,
    weekHealth,
    total: grandTotal,
    health: null,
  };
  return [totalsRow, ...customers];
};
